export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_polvo_invest.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a Polvo Invest",
    text: [
      "Somos especialistas no desenvolvimento de portfólios de estratégias automatizadas utilizando inteligência artificial. Nossas estratégias possuem baixíssima correlação e são validadas através de diversos testes de robustez estatística.",
    ],
    testimonial: {
      text: "“Para mim, tempo livre é a verdadeira ostentação.”",
      author: {
        name: "Felipe Ravanini, fundador Polvo Invest",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Números da Polvo Invest",
    subtitle: "Anos de trabalho, estudos e dedicação para criar portfólios sólidos e de alta rentabilidade ",
    data: [
      {
        value: "+14",
        description: "Anos de experiência ",
      },
      {
        value: "+3",
        description: "Anos de desenvolvimento em tempo integral",
      },
      {
        value: "+150",
        description: "Estratégias validadas",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Polvo Invest?",
    subtitle: "Veja quais as principais vantagens dos robôs da Polvo Invest.",
    data: [
      {
        title: "Liberdade total ",
        description: "Viva a sua vida enquanto nossos robôs trabalham pra você. ",
      },
      {
        title: "Tecnologia de ponta",
        description: "Estratégias criadas com inteligência artificial avançada. ",
      },
      {
        title: "Validação estatística",
        description: "Estratégias validadas através de complexos testes estatísticos.",
      },
      {
        title: "100% automatizado",
        description: "Nossos robôs operam 100% de forma automatizada, sem intervenção humana e sem emocional. ",
      },
      {
        title: "Estratégias descorrelacionadas",
        description:
          "Estratégias com baixíssima correlação entre si, gerando um portfólio equilibrado e com ótima relação risco/retorno.",
      },
      {
        title: "Suporte individual",
        description: "Atendimento rápido e de qualidade para solução de todas as suas dúvidas.",
      },
    ],
  },
  cta: {
    title: "Pronto pra buscar sua liberdade?",
    subtitle: "Conheça já os nossos planos!",
  },
  about: {
    title: "Sobre a empresa",
    col1: [
      "Tenho 14 anos de experiência no mercado financeiro, sendo os últimos 6 como trader profissional e 3 como trader quantitativo. ",
      "Resolvi me dedicar 100% à criação de estratégias automatizadas para ter mais tempo livre e viver a vida intensamente enquanto meus robôs trabalham por mim. ",
    ],
    col2: [
      "Criei a Polvo Invest com esse objetivo: trazer mais liberdade para meus clientes, ajudando pessoas como você a investir com inteligência, controle e segurança e ter mais liberdade de tempo e financeira. ",
      "Não prometo lucros fáceis, mas sim estratégias testadas e validadas, com resultados transparentes, usando o que há de mais moderno em automação com IA. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Polvo Invest",
  },
  strategies: {
    title: "ESTRATÉGIAS POLVO INVEST",
    heading: "Estratégias inteligentes para te dar mais liberdade",
    subtitle: "Estratégias criadas com IA e validadas através de diversos testes estatísticos.",
  },
  testimonials: [
    {
      text: "Felipe desde o começo sempre foi muito transparente em relação às estatísticas e aos riscos das estratégias, principalmente porque eu nunca tinha usado robôs. Sempre tive muita confiança e minha rentabilidade tem sido excelente!",
      author: "Victor Santos",
      job: "Consultor empresarial",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Acompanho o desenvolvimento das estratégias da Polvo há muito tempo e sei que ele faz um trabalho sério e dedicado. Uso desde o começo e recomendo!",
      author: "Gabriel M.",
      job: "Planejador financeiro",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
